// ABOUTME: Public /auth/* route subtree — rendered OUTSIDE the app's me-gate (no UserProvider).
// ABOUTME: Flag ON → in-app Kratos screens; flag OFF → external auth redirect. Owns /auth/callback.

import type { FC } from "react"
import { Navigate, Route, Routes } from "react-router"
import { isInAppAuthEnabled } from "@/model/auth/inAppAuthFlag"
import { AuthLayout } from "./AuthLayout"
import { ExternalAuthRedirect } from "./ExternalAuthRedirect"
import { LoginPage } from "./LoginPage"
import { RegistrationPage } from "./RegistrationPage"
import { RecoveryPage } from "./RecoveryPage"
import { VerificationPage } from "./VerificationPage"
import { MobileReturnPage } from "./MobileReturnPage"
import { CALENDAR_PAGE, LOGIN_PAGE } from "@shared/constants/navigation"

export const PublicAuthRoutes: FC = () => {
  const inApp = isInAppAuthEnabled()

  return (
    <Routes>
      {/*
        Kratos lands the user on `/auth/callback?kratos_session_token=…` after a
        successful login (the path is appended on the auth-API side). `authSupport.init()`
        already pulled the token off `URLSearchParams` at module load, so by the time the
        router matches here we can drop the search string and hand off to the app. A
        dedicated route (rather than the catch-all) keeps the path out of 404 telemetry
        and avoids leaking the JWT into Sentry via NotFoundPage's captureMessage.
        (Honoring `return_to` here is a Phase-1 follow-up.)
        `fromAuth` keeps the UserProvider loader on the auth screens' dark
        background during the login → app hand-off (no white flash).
      */}
      <Route
        path="/auth/callback"
        element={
          <Navigate
            to={CALENDAR_PAGE}
            replace
            state={{ fromAuth: true }}
          />
        }
      />

      {/*
        Return leg of the native app's Custom Tab OIDC flow — available in BOTH
        flag states (like /auth/callback): the flow's return_to is baked in by
        the app and must resolve regardless of how this browser session is
        flagged. Mints the mobile JWT and bounces to /auth/callback.
      */}
      <Route
        path="/auth/mobile-return"
        element={<MobileReturnPage />}
      />

      {inApp ? (
        <>
          <Route
            path="/auth/login"
            element={
              <AuthLayout>
                <LoginPage />
              </AuthLayout>
            }
          />
          <Route
            path="/auth/registration"
            element={
              <AuthLayout>
                <RegistrationPage />
              </AuthLayout>
            }
          />
          <Route
            path="/auth/recovery"
            element={
              <AuthLayout>
                <RecoveryPage />
              </AuthLayout>
            }
          />
          <Route
            path="/auth/verification"
            element={
              <AuthLayout>
                <VerificationPage />
              </AuthLayout>
            }
          />
          <Route
            path="/auth/*"
            element={
              <Navigate
                to={LOGIN_PAGE}
                replace
              />
            }
          />
        </>
      ) : (
        <Route
          path="/auth/*"
          element={<ExternalAuthRedirect />}
        />
      )}
    </Routes>
  )
}
